export default {
  state: {
    typeList: [
      { id: 'chatterbox', name: 'Chatterbox' },
      { id: 'linkbuilding', name: 'LinkBuilding' },
      { id: 'review', name: 'Review' },
      { id: 'seo', name: 'SEO' },
      // { id: 'translation', name: 'Translation' },
    ],
  },
  getters: {
    typeList(state) {
      return state.typeList
    },
  },
}
